// Lightweight i18n: English / Hindi / Telugu
const dict = {
    en: {
        app_tagline: "Order food, the smart way",
        search_placeholder: "Search dishes, restaurants or groceries",
        voice_hint: "Tap mic and speak in Hindi, Telugu or English",
        login_title: "Login or Sign up",
        login_subtitle: "Get \u20B950 off on first order",
        mobile_placeholder: "Mobile number",
        send_otp: "Send OTP",
        verify_otp: "Verify OTP",
        otp_placeholder: "Enter 6-digit OTP",
        cart_empty: "Your cart is empty",
        cart_browse: "Browse restaurants",
        view_cart: "View Cart",
        place_order: "Place Order",
        delivered_to: "Deliver to",
        veg_only: "Veg only",
        all: "All",
        non_veg: "Non-veg",
        popular_near_you: "Popular near you",
        featured: "Featured",
        offers_for_you: "Offers for you",
        explore_categories: "Explore categories",
        order_placed: "Order placed!",
        track_order: "Track order",
        my_orders: "My Orders",
        wallet: "Wallet",
        wallet_balance: "Wallet Balance",
        coupons: "Coupons",
        profile: "Profile",
        logout: "Logout",
        home: "Home",
        search: "Search",
        catalog: "Catalog",
        shops: "Shops",
        offers: "Offers",
        account: "Account",
        bestseller: "Bestseller",
        add: "ADD",
        customise: "Customise",
        rating: "Rating",
        delivery_in: "Delivery in",
        mins: "mins",
        free_delivery: "Free delivery",
        subtotal: "Subtotal",
        taxes: "Taxes & charges",
        delivery_fee: "Delivery fee",
        discount: "Discount",
        to_pay: "To Pay",
        apply_coupon: "Apply Coupon",
        payment_method: "Payment Method",
        cod: "Cash on Delivery",
        razorpay: "Pay Online (Razorpay)",
        use_wallet: "Use Wallet",
    },
    hi: {
        app_tagline: "\u0938\u094D\u092E\u093E\u0930\u094D\u091F \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0916\u093E\u0928\u093E \u0911\u0930\u094D\u0921\u0930 \u0915\u0930\u0947\u0902",
        search_placeholder: "\u0935\u094D\u092F\u0902\u091C\u0928, \u0930\u0947\u0938\u094D\u091F\u094B\u0930\u0947\u0902\u091F \u092F\u093E \u0915\u093F\u0930\u093E\u0928\u093E \u0916\u094B\u091C\u0947\u0902",
        voice_hint: "\u092E\u093E\u0907\u0915 \u0926\u092C\u093E\u090F\u0902 \u0914\u0930 \u092C\u094B\u0932\u0947\u0902",
        login_title: "\u0932\u0949\u0917\u093F\u0928 \u092F\u093E \u0938\u093E\u0907\u0928 \u0905\u092A",
        send_otp: "OTP \u092D\u0947\u091C\u0947\u0902",
        verify_otp: "OTP \u091C\u093E\u0902\u091A\u0947\u0902",
        cart_empty: "\u0906\u092A\u0915\u0940 \u091F\u094B\u0915\u0930\u0940 \u0916\u093E\u0932\u0940 \u0939\u0948",
        view_cart: "\u091F\u094B\u0915\u0930\u0940 \u0926\u0947\u0916\u0947\u0902",
        place_order: "\u0911\u0930\u094D\u0921\u0930 \u0915\u0930\u0947\u0902",
        my_orders: "\u092E\u0947\u0930\u0947 \u0911\u0930\u094D\u0921\u0930",
        wallet: "\u0935\u0949\u0932\u0947\u091F",
        coupons: "\u0915\u0942\u092A\u0928",
        profile: "\u092A\u094D\u0930\u094B\u092B\u093C\u093E\u0907\u0932",
        home: "\u0939\u094B\u092E",
        search: "\u0916\u094B\u091C",
        offers: "\u0911\u092B\u093C\u0930",
        account: "\u0916\u093E\u0924\u093E",
        add: "\u091C\u094B\u0921\u093C\u0947\u0902",
        free_delivery: "\u092B\u094D\u0930\u0940 \u0921\u093F\u0932\u093F\u0935\u0930\u0940",
        cod: "\u0915\u0948\u0936 \u0911\u0928 \u0921\u093F\u0932\u093F\u0935\u0930\u0940",
    },
    te: {
        app_tagline: "\u0AB8\u0AAE\u0BBE\u0CB0\u0BCD\u0C9F\u0CCD \u0C97\u0CBE \u0C2C\u0CC1\u0C95\u0BCD \u0C9A\u0BC7\u0BAF\u0BBF",
        search_placeholder: "\u0C35\u0C82\u0C9F\u0C95\u0BBE\u0BB2\u0BC1, \u0CB0\u0BC6\u0BB8\u0BCD\u0C9F\u0BBE\u0C30\u0BC7\u0C82\u0C9F\u0BCD\u0BB2\u0BC1 \u0C35\u0BC6\u0CA4\u0C95\u0C82\u0CA1\u0BBF",
        voice_hint: "\u0CAE\u0BC8\u0C95\u0BCD \u0CA8\u0BCA\u0C95\u0BCD\u0C95\u0BBF \u0CAE\u0BBE\u0C9F\u0BCD\u0C9F\u0BBE\u0CA1\u0BBF",
        login_title: "\u0CB2\u0BBE\u0C97\u0BBF\u0CA8\u0BCD \u0CB2\u0BC7\u0CA6\u0BBE \u0CB8\u0BC8\u0CA8\u0BCD \u0C85\u0BAA\u0BCD",
        send_otp: "OTP \u0CAA\u0C82\u0CAA\u0C82\u0CA1\u0BBF",
        verify_otp: "OTP \u0CA7\u0BC1\u0CB5\u0BC0\u0C95\u0CB0\u0BBF\u0C82\u0C9A\u0C82\u0CA1\u0BBF",
        cart_empty: "\u0CAE\u0BC0 \u0C95\u0BBE\u0CB0\u0BCD\u0C9F\u0BCD \u0C96\u0BBE\u0CB2\u0BBF\u0C97\u0BBE \u0C89\u0C82\u0CA6\u0BBF",
        view_cart: "\u0C95\u0BBE\u0CB0\u0BCD\u0C9F\u0BCD \u0C9A\u0BC2\u0CA1\u0C82\u0CA1\u0BBF",
        place_order: "\u0C86\u0CB0\u0BCD\u0CA1\u0CB0\u0BCD \u0CA8\u0BBF\u0CB2\u0CC1\u0CAA\u0C82\u0CA1\u0BBF",
        my_orders: "\u0CA8\u0BBE \u0C86\u0CB0\u0BCD\u0CA1\u0CB0\u0BCD\u0CB2\u0BC1",
        wallet: "\u0CB5\u0BBE\u0CB2\u0BC6\u0C9F\u0BCD",
        coupons: "\u0C95\u0BC2\u0CAA\u0CA8\u0BCD\u0CB2\u0BC1",
        profile: "\u0CAA\u0BCD\u0CB0\u0BCB\u0CAB\u0BC8\u0CB2\u0BCD",
        home: "\u0CB9\u0BCB\u0C82",
        search: "\u0CB5\u0BC6\u0CA4\u0C95\u0C82",
        offers: "\u0C86\u0CB0\u0BCD\u0CB8",
        account: "\u0C96\u0BBE\u0CA4\u0BBE",
        add: "\u0C9C\u0BCB\u0CA1\u0BBF\u0C82\u0C9A\u0C82\u0CA1\u0BBF",
        free_delivery: "\u0CAB\u0BCD\u0CB0\u0BC0 \u0CA1\u0BC6\u0CB2\u0BBF\u0CB5\u0CB0\u0BBF",
        cod: "\u0CA1\u0BC6\u0CB2\u0BBF\u0CB5\u0CB0\u0BBF\u0C95\u0BBF \u0CA8\u0C97\u0CA6\u0BC1",
    },
};

export const languages = [
    { code: "en", label: "English" },
    { code: "hi", label: "\u0939\u093F\u0928\u094D\u0926\u0940" },
    { code: "te", label: "\u0C24\u0C46\u0CB2\u0CC1\u0C97\u0CC1" },
];

export function t(key, lang = "en") {
    return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
}
